/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Google_Auth_DescriptionInputs */

const en_admin_settings_groups_google_auth_description = /** @type {(inputs: Admin_Settings_Groups_Google_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google OAuth login`)
};

/**
* | output |
* | --- |
* | "Google OAuth login" |
*
* @param {Admin_Settings_Groups_Google_Auth_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_google_auth_description = /** @type {((inputs?: Admin_Settings_Groups_Google_Auth_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Google_Auth_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_google_auth_description(inputs)
});
export { admin_settings_groups_google_auth_description as "admin.settings.groups.google_auth.description" }